import { Close as CloseIcon, Undo as UndoIcon } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useDeleteChat } from 'applications/GSP/pages/ParentHelper/components/History/hooks';
import { Button } from 'shared/components/buttons/Button';

import { useDiscardChatDeleting } from './hooks';

import type { FC } from 'react';

export const SnackbarActionsButton: FC = () => {
  const { t } = useTranslation();
  const onDeleteChat = useDeleteChat();
  const onDiscardDeleting = useDiscardChatDeleting();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: ' repeat(3, auto)',
        alignItems: 'center',
      }}
    >
      <Button
        startIcon={<UndoIcon fontSize="small" />}
        onClick={onDiscardDeleting}
        color="inherit"
      >
        <Typography noWrap variant="subtitle2" color="common.white">
          {t('GSP.pages.parentHelper.history.deleteSnackbar.undo')}
        </Typography>
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={onDeleteChat}
        sx={{ ml: '8px' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
